import configService from './config.service';

const getAll = async (authToken) => {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${authToken}`);

    const options = {
        method: 'GET',
        headers: headers
    };

    const response = await fetch(`${configService.appConfig.baseApiEndpoint}/office/all`, options);

    if (!response.ok) {
        const message = `An error occurred: ${response.statusText}`;
        console.error(message);
        return;
    }

    const jsonData = await response.json();
    return jsonData;
};

const getById = async (authToken, officeId) => {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${authToken}`);

    const options = {
        method: 'GET',
        headers: headers
    };

    const response = await fetch(`${configService.appConfig.baseApiEndpoint}/office/Id/${officeId}`, options);

    if (!response.ok) {
        const message = `An error occurred: ${response.statusText}`;
        console.error(message);
        return;
    }

    const jsonData = await response.json();
    return jsonData;
};

const save = async (authToken, office) => {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${authToken}`);
    headers.append('Content-Type', 'application/json');

    const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(office)
    };

    const response = await fetch(`${configService.appConfig.baseApiEndpoint}/office/save`, options);

    if (!response.ok) {
        const message = `An error occurred: ${response.statusText}`;
        console.error(message);
        return;
    }

    const jsonData = await response.json();
    return jsonData;
};

export default { getAll, getById, save };
